

import store_app from "./store_app";
import store_restaurant from "./store_restaurant";
import store_onlineOrders from "./store_onlineOrders";
import store_previsionperformance from "./store_previsionperformance";
import { createStore } from 'vuex';
/*
const isDev = process.env.NODE_ENV === "local";
export default createStore({
    strict:isDev,
    modules: { store_app,store_restaurant },
});
*/

// Fusionner state
const state = {
    ...store_app.state,
    ...store_restaurant.state,
    ...store_onlineOrders.state,
    ...store_previsionperformance.state,
}

// Fusionner getters
const getters = {
    ...store_app.getters,
    ...store_restaurant.getters,
    ...store_onlineOrders.getters,
    ...store_previsionperformance.getters,
}

// Fusionner mutations
const mutations = {
    ...store_app.mutations,
    ...store_restaurant.mutations,
    ...store_onlineOrders.mutations,
    ...store_previsionperformance.mutations,
}

// Fusionner actions
const actions = {
    ...store_app.actions,
    ...store_restaurant.actions,
    ...store_onlineOrders.actions,
    ...store_previsionperformance.actions,
}

// Créer le store global
const isDev = process.env.NODE_ENV === 'local'

export default createStore({
    strict: isDev,
    state,
    getters,
    mutations,
    actions
})






